module.exports = __webpack_public_path__ + "static/media/blogtestpic1.6e12b121.jpg";